<app-menu></app-menu>
<mat-toolbar color="primary"> Logs </mat-toolbar>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" #scrollContainer>
  <ng-container matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef>Timestamp</th>
    <td mat-cell *matCellDef="let element">
      {{ element.timestamp | date: "medium":"+0200":"de" }}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
  </ng-container>
  <ng-container matColumnDef="context">
    <th mat-header-cell *matHeaderCellDef>Context</th>
    <td mat-cell *matCellDef="let element">{{ element.context }}</td>
  </ng-container>
  <ng-container matColumnDef="message">
    <th mat-header-cell *matHeaderCellDef>Message</th>
    <td mat-cell *matCellDef="let element">{{ element.message }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<div *ngIf="loading" class="loading-spinner">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons [length]="totalLength"
  (page)="onPageChange($event)">
</mat-paginator>